import URL from 'url'

import Axios from 'axios'
import Cookies from 'js-cookie'
import { saveAs } from 'file-saver'

const ENV = process.env.REACT_APP_ENV
const endpoint = process.env[`REACT_APP_ENDPOINT_${ENV}`]

export const fetch = async ({
  method = 'get', url, data, query,
}) => {
  const headers = { 'Content-Type': 'application/json; charset=utf-8' }
  if (Cookies.get(`oms-token-${process.env.REACT_APP_ENV}`)) headers.Authorization = Cookies.get(`oms-token-${process.env.REACT_APP_ENV}`)
  try {
    const response = await Axios({
      method,
      url: `${endpoint}${url}${URL.format({ query })}`,
      data,
      headers,
    })
    return { status: response.status, data: response.data }
  } catch (error) {
    if (error.response) {
      if (error.response.status === 440) {
        Cookies.remove(`oms-token-${process.env.REACT_APP_ENV}`)
        window.location.reload()
      }
      return { status: error.response.status, data: error.response.data }
    } if (error.request) {
      // The request was made but no response was received
      // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
      // http.ClientRequest in node.js
      console.log(error.request)

      return { status: '500', data: 'Server is out of reach' }
    }
    // Something happened in setting up the request that triggered an Error
    console.log('Error', error.message)
    return { status: '500', data: 'Fetch error' }
  }
}

export const fetchDownload = async ({
  method = 'get',
  url, fileName, data, query,
}) => {
  const headers = { 'Content-Type': 'application/json' }
  if (Cookies.get(`oms-token-${process.env.REACT_APP_ENV}`)) headers.Authorization = Cookies.get(`oms-token-${process.env.REACT_APP_ENV}`)
  try {
    const response = await Axios({
      method,
      url: `${endpoint}${url}${URL.format({ query })}`,
      data,
      headers,
      responseType: 'blob',
    })
    await saveAs(response.data, fileName)
    return { success: true }
  } catch (error) {
    if (error.response) {
      if (error.response.status === 440) {
        Cookies.remove(`oms-token-${process.env.REACT_APP_ENV}`)
        window.location.reload()
      }
      return { status: error.response.status, data: error.response.data }
    } if (error.request) {
      // The request was made but no response was received
      // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
      // http.ClientRequest in node.js
      console.log(error.request)

      return { status: '500', data: 'Server is out of reach' }
    }
    // Something happened in setting up the request that triggered an Error
    console.log('Error', error.message)
    return { status: '500', data: 'Fetch error' }
  }
}

export const fetchDownloadPDF = async ({
  method = 'get',
  url, fileName, body,
}) => {
  const headers = { 'Content-Type': 'application/pdf' }
  if (Cookies.get(`oms-token-${process.env.REACT_APP_ENV}`)) headers.Authorization = Cookies.get(`oms-token-${process.env.REACT_APP_ENV}`)
  const response = await Axios({
    url: `${endpoint}${url}`,
    method,
    body,
    headers,
    responseType: 'blob',
  })

  await saveAs(response.data, fileName)
  return { success: true }
}

export const upload = async () => {

}

export const fetchHomagQueue = async ({ method = 'POST', url, data }) => {
  const headers = { 'Content-Type': 'application/json; charset=utf-8' }
  try {
    const response = await Axios({
      method,
      url,
      data,
      headers,
    })
    return { status: response.status, data: response.data }
  } catch (error) {
    console.log('Error', error.message)
    return { status: '500', data: 'Fetch error' }
  }
}
